/* PrimaryAction · Constitutional Refactor · Batch C2b
 * =====================================================
 * The Attention Doctrine states: "one primary action leads at a
 * time". This primitive is the ONLY way a surface may render its
 * hero action. Doctrine tests count occurrences of the testid
 * across each surface to guarantee compliance.
 *
 * Constitutional articles served:
 *   • 4 (Better Decisions) — the user is never confused about
 *     which action leads.
 *   • 7 (Reduce Cognitive Load) — one lead, everything else waits.
 *
 * The `secondary` prop renders a docked, subordinate action
 * beside the primary. Never a floating alternative.
 */
export function PrimaryAction({
  onClick,
  disabled = false,
  children,
  secondary = null,
  testid = "primary-action",
  icon: Icon = null,
}) {
  return (
    <div
      data-testid={`${testid}-shell`}
      className="w-full flex items-center gap-2"
    >
      <button
        type="button"
        data-testid={testid}
        onClick={onClick}
        disabled={disabled}
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-slate-900 dark:bg-white text-white dark:text-slate-900 px-4 py-2.5 text-sm font-black hover:opacity-90 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-emerald-500"
      >
        {Icon && <Icon className="w-4 h-4" />}
        {children}
      </button>
      {secondary && (
        <div data-testid={`${testid}-secondary`} className="shrink-0">
          {secondary}
        </div>
      )}
    </div>
  );
}

export default PrimaryAction;
